/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';

/**
 * 
 * @export
 * @interface CreateLeadsBulk201Response
 */
export interface CreateLeadsBulk201Response {
    /**
     * 
     */
    data?: Array<FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead>;
}

/**
 * Check if a given object implements the CreateLeadsBulk201Response interface.
 */
export function instanceOfCreateLeadsBulk201Response(value: object): value is CreateLeadsBulk201Response {
    return true;
}

export function CreateLeadsBulk201ResponseFromJSON(json: any): CreateLeadsBulk201Response {
    return CreateLeadsBulk201ResponseFromJSONTyped(json, false);
}

export function CreateLeadsBulk201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadsBulk201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON)),
    };
}

export function CreateLeadsBulk201ResponseToJSON(json: any): CreateLeadsBulk201Response {
    return CreateLeadsBulk201ResponseToJSONTyped(json, false);
}

export function CreateLeadsBulk201ResponseToJSONTyped(value?: CreateLeadsBulk201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON)),
    };
}

